import { ARReportLayout } from './layouts';
import { ARHistoryView } from './components/ARHistoryView';

export function ARHistoryPage() {
  return (
    <ARReportLayout>
      <ARHistoryView />
    </ARReportLayout>
  );
}

